import React from "react";

const OnlyYearRange = ({ fromYear, toYear }) => {
  if (!fromYear) return null;

  const extractYear = (value) => {
    if (!value) return null;

    // get first 4 digit year from string
    const match = value.toString().match(/\d{4}/);
    return match ? parseInt(match[0], 10) : null;
  };

  const startYear = extractYear(fromYear);
  const endYear =
    !toYear || toYear === "Present"
      ? new Date().getFullYear()
      : extractYear(toYear);

  if (!startYear || !endYear) return null;

  let displayText = "";

  if (startYear === endYear) {
    displayText = "Less than 1 Year";
  } else {
    const yearDiff = endYear - startYear;
    displayText = `${yearDiff} Year${yearDiff > 1 ? "s" : ""}`;
  }

  return (
    <p>
      {startYear} - {toYear === "Present" || !toYear ? "Present" : endYear}{" "}
      <span>({displayText})</span>
    </p>
  );
};

export default OnlyYearRange;